import {
	PROMOTION_SAVED,
	PROMOTION_UPDATE_TEXTFIELD_VALUE,
	PROMOTION_UPDATE_POSITION_VALUE,
	PROMOTION_ADD_PERIOD,
	PROMOTION_ADD_PERIOD_VARIANT,
	PROMOTION_UPDATE_POSITION_FIELD_VALUE,
	PROMOTION_SET,
	PROMOTION_RESET,
	PROMOTION_UPDATE_PERIOD_FIELD_VALUE,
	PROMOTION_REMOVE_VARIATION, PROMOTION_REMOVE_PERIOD
} from "../constants"

import { types } from "../api/promotions/index"

import { api } from "../api/index"

const initialState = {
	deletedVariants: [],
	name: '',
	campaign: '',
	url: 'https://',
	position: '',
	priority: 'default',
	companyUrl: '',
	postIds: [],
	topicIds: [],
	authorIds: [],
	productType: '',
	startDateTimeStamp: Date.now(),
	maxViews: 0,
	endDateTimeStamp: null,
	label: '',
	categoryIds: [],
	autoAbTest: false,
	hideBrandedInfo: false,
	periods: [
		{
			startDateTimeStamp: Date.now(),
			endDateTimeStamp: Date.now(),
			periodName: '',
			variants: [
				{
					title: '',
					text: '',
					image: {},
					ctatext: '',
					label: 'Advertorial',
					active: true,
					selectedPost: 0,
					url: '',
					ctaText: '',
					chip: '',
				},
			]
		},
	]
};

export const PromotionReducer = (state = initialState, action ) => {
	switch ( action.type ) {
		case PROMOTION_REMOVE_PERIOD :
			state = {
				...state,
				periods: [
					...state.periods.filter( period => {
						return period.key !== action.payload.period.key;
					})
				]
			};
			break;
		case PROMOTION_SAVED :
			state = {
				...state,
				open: true,
				message: action.payload.message
			};
			break;
		case PROMOTION_UPDATE_TEXTFIELD_VALUE :
			state = {
				...state,
				[ action.payload.name ]: action.payload.value
			};
			break;
		case PROMOTION_UPDATE_POSITION_VALUE :
			state = {
				...state,
				position: action.payload.position
			};
			break;
		case PROMOTION_ADD_PERIOD:
				const { periods } = { ...state };

				const periodToAdd = false !== action.payload.period ? action.payload.period : {...initialState.periods[0]};

				periods.push(periodToAdd);

				state = {
					...state,
					periods: periods
				};

			break;
		case PROMOTION_ADD_PERIOD_VARIANT :
			// console.log( action.payload.variant );
			// console.log( initialState.periods[0].variants[0] );
			//
			state = {
				...state,
				periods: [
					...state.periods.map((item, index) => {
						if ( index !== action.payload.period ) {
							return item;
						}

						return {
							...item,
							variants: [
								...item.variants,
								( action.payload.variant !== false ? action.payload.variant : initialState.periods[0].variants[0] )
							]
						}
					})
				]
			};

			break;
		case PROMOTION_UPDATE_POSITION_FIELD_VALUE :
			state = {
				...state,
				periods: [
					...state.periods.map((item, index) => {
						if ( index !== action.payload.periodKey ) {
							return item;
						}

						return {
							...item,
							variants: [
								...item.variants.map((item, index) => {
									if ( index !== action.payload.variantKey ) {
										return item;
									}

									// console.log( action.payload.name, action.payload.value);

									return {
										...item,
										[action.payload.name]: action.payload.value
									}
								})
							]
						}
					})
				]
			};

			break;
		case PROMOTION_UPDATE_PERIOD_FIELD_VALUE :
				state = {
					...state,
					periods: [
						...state.periods.map((item, index) => {
							if ( index !== action.payload.periodKey ) {
								return item;

							}

							return {
								...item,
								[action.payload.name]: action.payload.value
							}
						})
					]
				};
			break;
		case PROMOTION_SET :
			state = action.payload.promotion;
			break;

		case PROMOTION_RESET :
				state = initialState;
			break;
		case PROMOTION_REMOVE_VARIATION :
				state = {
					...state,
					periods: [
						...state.periods.map((item, index) => {
							if ( index !== action.payload.periodKey ) {
								return item;
							}

							return {
								...item,
								variants: [
									...item.variants.filter((item, index) => {
										return index !== action.payload.variantKey;
									})
								]
							}
						})
					]
				};
			break;

		default:
			return state;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/reducers/promotion.js